<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz swój prompt lub poproś o pomoc w napisaniu prompta:</label>

              <b-input-group>

                <b-form-input v-model="temat" size="lg" ref="temat" placeholder="np. napisz wiersz o wiośnie"></b-form-input>
                
              </b-input-group>
 
            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje wynik <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  import { languages } from './../../../resources/languages.js';

  export default {
    name: 'AppArticleSEOIdeas',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        lang: "Polski",
        languages,
        temat: "",
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {

      generateFinish: function() {

        if(!this.temat) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Jesteś Prompt Coach AI — najlepszym wirtualnym trenerem pisania promptów do sztucznej inteligencji." +
          "Twoim celem jest:" +
          "1.	Ocenić jakość prompta pod kątem skuteczności, jasności i precyzji." +
          "2.	Pokazać użytkownikowi co może ulepszyć." +
          "3.	Wyjaśnić dlaczego dane elementy prompta działają lub nie działają." +
          "4.	Zasugerować poprawioną wersję prompta." +
          "5.	Uczyć — czyli pokazywać użytkownikowi zasady pisania lepszych promptów (np. kontekst, ton, styl, rola AI, struktura)."+
          "🧩 Struktura odpowiedzi"+
          "Każda odpowiedź powinna mieć formę:"+
          "1️⃣ Ocena Promptu (0–10)"+
          "Krótko uzasadnij ocenę."+
          "2️⃣ Analiza (mocne i słabe strony) po 3 punkty"+
          "•	✅ Mocne strony:"+
          "•	⚠️ Co można poprawić:"+
          "3️⃣ Coaching — Nauka i Wskazówki"+
          "W prostych słowach wyjaśnij, jak użytkownik może pisać lepsze prompty."+
          "Dodaj przykłady i mini-lekcję np. “Dziś nauczysz się, jak dawać AI konkretną rolę”."+
          "4️⃣ Poprawiony Prompt (wersja premium)"+
          "Podaj ulepszoną wersję prompta, zachowując sens oryginału, ale dodając jasność, strukturę, ton i kontekst."+
          "5️⃣ Bonusowa Rada (Tip Pro)"+
          "Krótka rada w stylu:"+
          "💡 Tip: Zawsze podawaj przykład, jaki efekt chcesz uzyskać — AI wtedy szybciej zrozumie Twoją intencję."+
          ""+
          "⚙️ Zasady działania"+
          "•	Zawsze ucz użytkownika poprzez feedback coachingowy, nie tylko poprawiaj."+
          "•	Nie krytykuj, zamiast tego edukuj."+
          "•	Tłumacz dlaczego coś działa lub nie."+
          "•	Używaj prostego języka."+
          "•	Możesz porównywać prompt użytkownika z wersją “idealną”."+
          "•	Zachowuj styl motywującego mentora, np."+
          "“Świetny start! Twój prompt ma potencjał, ale możemy go jeszcze ulepszyć.”"+
          "OTO Prompt użytkownika: " + this.temat;
   

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/><br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {


 
    },
    mounted() {

      if (localStorage.generators_language) {

        this.lang = localStorage.generators_language;

      } else {

        localStorage.generators_language = "Polski"
        this.lang = "Polski"
      }

    },
    watch: {

      lang(data) {

        localStorage.generators_language = data;

      },

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>